import { render, staticRenderFns } from "./RuleListForm.vue?vue&type=template&id=461f4ee1&scoped=true"
import script from "./RuleListForm.vue?vue&type=script&lang=js"
export * from "./RuleListForm.vue?vue&type=script&lang=js"
import style0 from "./RuleListForm.vue?vue&type=style&index=0&id=461f4ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f4ee1",
  null
  
)

export default component.exports